/**
 * SHABTA — view-transitions.js (FULLY DISABLED)
 * ==============================================
 * Stops Horizon page morphs that grow into a giant "Q" / smashed header icons.
 * Safe: no observers, no loops.
 */
(function () {
  try {
    var blocker = document.getElementById('view-transition-render-blocker');
    if (blocker) blocker.remove();
  } catch (e) {}

  try {
    document.querySelectorAll('meta[name="view-transition"]').forEach(function (m) {
      m.remove();
    });
  } catch (e) {}

  // Hard override — any document.startViewTransition call becomes a normal update
  try {
    document.startViewTransition = function (cb) {
      var result = typeof cb === 'function' ? cb() : undefined;
      return {
        ready: Promise.resolve(),
        finished: Promise.resolve(result),
        updateCallbackDone: Promise.resolve(result),
        skipTransition: function () {},
        types: { add: function () {}, clear: function () {}, has: function () { return false; } }
      };
    };
  } catch (e) {}

  function skipAllViewTransitions(event) {
    try {
      var vt = event && event.viewTransition;
      if (vt && typeof vt.skipTransition === 'function') {
        vt.skipTransition();
      }
    } catch (e) {}

    try {
      sessionStorage.removeItem('custom-transition-type');
    } catch (e) {}
  }

  window.addEventListener('pageswap', skipAllViewTransitions, true);
  window.addEventListener('pagereveal', skipAllViewTransitions, true);
  window.addEventListener('pageswap', skipAllViewTransitions, false);
  window.addEventListener('pagereveal', skipAllViewTransitions, false);
})();
